import { Checkbox, Row as RowAntd, Spin as SpinAntd } from 'antd';
import styled, { createGlobalStyle, css } from 'styled-components';

export const LegendList = styled.ul`
  padding: 0;
  margin: 0;
  text-align: right;

  li {
    display: inline-block;
    margin-right: 10;
  }
`;

export const CheckBoxLegend = styled(Checkbox)`
  .ant-checkbox-checked > .ant-checkbox-inner {
    ${props =>
      props.color &&
      css`
        background-color: ${props.color} !important;
        border-color: ${props.color} !important;
      `}
  }
`;

export const Spin = styled(SpinAntd)`
  max-height: 100% !important;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;

export const Container = styled(RowAntd)`
  height: 276px;
`;

export const Styles = createGlobalStyle`

  @media only screen and (min-width: 1200px) {
    .margin-top-media {
      margin-top: 24px;
      text-align: end !important;
    }
  }

  @media only screen and (max-width: 1200px) {
    .margin-top-media {
      margin-bottom: 24px;
    }
  }

  .chart-custom {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .chart-custom-loading {
    width: 100%;
    margin-top: 10px;
    .recharts-wrapper {
      opacity: 0.5;
    }
  }
`;
